import React from "react";
import ReactDOM from "react-dom";
import { Provider as ReduxProvider } from "react-redux";
import { createStore } from "redux";
import { AppContainer } from "react-hot-loader";
import ReactGA from "react-ga";

import routes from "package-common-react/lib/routes";

// import "./import/stores";

import {
  init,
  FirebaseAppProvider
} from "package-common-react/lib/util/firebase";

import App from "./App";
import registerServiceWorker from "package-common-react/lib/registerServiceWorker";
import reducer from "package-common-react/lib/stores";
import config from './config';

routes.home.path = '/home';

const firebaseApp = init(config.firebase);
ReactGA.initialize(config.googleAnalytics.id, {
  debug: false,
});

const reduxState = window.__REDUX_STATE__;
delete window.__REDUX_STATE__;
const store = createStore(
  reducer,
  (window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__()) ||
    reduxState
);

const render = Component => {
  ReactDOM.render(
    // Wrap App inside AppContainer
    <AppContainer>
      <FirebaseAppProvider value={firebaseApp}>
        <ReduxProvider store={store}>
            <Component />
        </ReduxProvider>
      </FirebaseAppProvider>
    </AppContainer>,
    document.getElementById("root")
  );
};

registerServiceWorker();
render(App);

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept("./App", () => {
    render(App);
  });
}



// WEBPACK FOOTER //
// ./src/index.js